import { render, staticRenderFns } from "./DashboardStatsSection.vue?vue&type=template&id=c880c08e&scoped=true&"
import script from "./DashboardStatsSection.vue?vue&type=script&lang=js&"
export * from "./DashboardStatsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c880c08e",
  null
  
)

export default component.exports